import { createRootRoute, Outlet } from "@tanstack/react-router";

/**
 * The root route. It only renders an `<Outlet />` so that nested layouts
 * (the authenticated `_app` shell, future public pages, etc.) can fully
 * own their chrome.
 */
export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
